import React, { useState } from "react";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
  getAuth,
} from "firebase/auth";
import { addDoc, doc, setDoc } from "firebase/firestore";
import { auth, db } from "../../shared/FirebaseConfig";
import "./signin.scss";
import "./resetPassword.scss";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { Icon } from "@iconify/react/dist/iconify.js";
import { GoArrowLeft } from "react-icons/go";
import { RxCross1 } from "react-icons/rx";
import { IoEyeOffSharp, IoEyeSharp } from "react-icons/io5";

function SignIn() {
  const Apiurl = process.env.REACT_APP_API_KEY;
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [restpassword, setResetpassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);

  const [step, setStep] = useState(1);
  const [sending, setsending] = useState(false);

  const [otp, setOtp] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    otp: "",
    password: "",
    confirmPassword: "",
  });

  const handleClose = () => {
    setShow(false);
    setStep(1);
    setErrors({
      email: "",
      otp: "",
      password: "",
      confirmPassword: "",
    });
    return;
  };

  const handleShow = () => {
    setShow(true);
    setErrors({
      email: "",
      otp: "",
      password: "",
      confirmPassword: "",
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const validate = () => {
    let valid = true;
    if (!email) {
      setErrors((prev) => ({ ...prev, email: "Email is required." }));
      valid = false;
    }
    if (!password) {
      setErrors((prev) => ({ ...prev, password: "Password is required." }));
      valid = false;
    }
    return valid;
  };

  const loginApi = () => {
    if (!validate()) return;
    axios
      .post(`${Apiurl}/login`, {
        email: email,
        password: password,
      })
      .then((res) => {
        const token = res.data.token;
        console.log(token);
        localStorage.setItem("authToken", token);
        toast.success("Login Successfully", {
          toastId: "loginsuccess",
        });
        navigate("/systemprompt");
      })
      .catch((err) => {
        toast.error("Invalid Credentials", { toastId: "loginfailure" });
        const errorResponse = err.response.data;

        console.log(err);
        return;
      });
  };

  const forgetPassword = () => {
    setsending(true);
    axios
      .post(`${Apiurl}/forgot_password`, {
        email: email,
      })
      .then((res) => {
        setStep(2);
        setsending(false);
        toast.success(res.data.message, {
          toastId: "loginsuccess",
        });
      })
      .catch((err) => {
        setsending(false);
        toast.error("User not Exists", { toastId: "OTPfailure" });
        setErrors((prev) => ({ ...prev, email: "User not Exists" }));
      });
  };

  const resetpassword = () => {
    if (restpassword !== confirmPassword) {
      setErrors((prev) => ({
        ...prev,
        confirmPassword: "Passwords do not match.",
      }));
      return;
    }
    axios
      .post(`${Apiurl}/verify_recovery_code`, {
        code: otp,
      })
      .then((res) => {
        axios
          .post(`${Apiurl}/reset_password`, {
            email: email,
            code: otp,
            new_password: restpassword,
            confirm_password: confirmPassword,
          })
          .then((response) => {
            setShow(false);
            toast.success("Password Reset Successfully!", {
              toastId: "passwordsuceess",
            });
          })
          .catch((error) => {
            toast.error("Error resetting password", { toastId: "reset" });
            setErrors((prev) => ({
              ...prev,
              password: "Error resetting password.",
            }));
          });
      })
      .catch((err) => {
        setErrors((prev) => ({ ...prev, otp: "Incorrect OTP." }));
      });
  };

  return (
    <>
      <div className="sign_in">
        <div className="main">
          <div className="logo">
            <div className="logo_icon">
              <img src="/nextgen_logo.png" alt="" />
            </div>
            <img src="/nextgen_text.png" alt="" />
          </div>

          <div className="inputs input-wrapper">
            <div className="input">
              <p>Email</p>
              <input
                type="email"
                onChange={(e) => {
                  setEmail(e.target.value.toLowerCase());
                  setErrors((prev) => ({ ...prev, email: "" }));
                }}
                value={email}
                placeholder="Enter Your Email"
                required
              />
              <span style={{ color: "red" }}>{errors.email}</span>
            </div>

            <div className="input">
              <p>Password</p>
              <div
                className="password-wrapper"
                style={{ position: "relative" }}
              >
                <input
                  type={showPassword ? "text" : "password"}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setErrors((prev) => ({ ...prev, password: "" }));
                  }}
                  value={password}
                  placeholder="Enter Your Password"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      loginApi();
                    }
                  }}
                  required
                />
                <span
                  className="toggle-password"
                  style={{
                    position: "absolute",
                    top: "20px",
                    bottom: "0px",
                    right: "20px",
                    cursor: "pointer",
                  }}
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <IoEyeOffSharp /> : <IoEyeSharp />}
                </span>
              </div>
              <span style={{ color: "red" }}>{errors.password}</span>
              <div onClick={handleShow} className="forgot_password">
                Forgot password?
              </div>
            </div>

            <div className="submit">
              <input type="submit" onClick={loginApi} value="Sign In" />
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="modelBody">
          <div className="signup-card">
            <div className="signupcard-content">
              <div className="main-card">
                {step == 1 ? (
                  <div
                    className="d-flex justify-content-end align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={handleClose}
                  >
                    <RxCross1 className="mb-1 w-2 h-2" />
                  </div>
                ) : (
                  <>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="back-btn">
                        <button onClick={() => setStep(1)}>
                          <GoArrowLeft className="mb-1 w-2 h-2" />
                          Back
                        </button>
                      </div>
                      <div style={{ cursor: "pointer" }} onClick={handleClose}>
                        <RxCross1 className="mb-1 w-2 h-2" />
                      </div>
                    </div>
                  </>
                )}

                <div className="cardtitle">
                  <div className="leftside">
                    <h6>{step === 1 ? "Enter Email" : "Reset Password"}</h6>
                  </div>
                  <div className="rightside">
                    <h6>
                      {step === 1
                        ? "Enter your email and OTP to verify."
                        : "Set the new password for your account so you can login and access all the features."}
                    </h6>
                  </div>
                </div>
                {step === 1 ? (
                  <div className="accountRecovery-middle">
                    <div className="firstfield">
                      <div className="label">
                        <label htmlFor="">Email</label>{" "}
                      </div>
                      <div className="inputfield">
                        <input
                          type="email"
                          placeholder="Email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setErrors((prev) => ({ ...prev, email: "" }));
                          }}
                        />
                      </div>
                      <span style={{ color: "red" }}>{errors.email}</span>
                    </div>
                    <div className="firstfield d-none">
                      <div className="label">
                        <label htmlFor="">OTP</label>{" "}
                      </div>
                      <div className="inputfield">
                        <input
                          type="number"
                          placeholder="Enter The OTP"
                          value={otp}
                          onChange={(e) => {
                            setOtp(e.target.value);
                            setErrors((prev) => ({ ...prev, otp: "" }));
                          }}
                        />
                      </div>
                      <span style={{ color: "red" }}>{errors.otp}</span>
                    </div>
                  </div>
                ) : (
                  <div className="accountRecovery-middle">
                    <div className="firstfield">
                      <div className="label">
                        <label htmlFor="">OTP</label>{" "}
                      </div>
                      <div className="inputfield">
                        <input
                          type="number"
                          placeholder="Enter The OTP"
                          value={otp}
                          onChange={(e) => {
                            setOtp(e.target.value);
                            setErrors((prev) => ({ ...prev, otp: "" }));
                          }}
                        />
                        <span style={{ color: "red" }}>{errors.otp}</span>
                      </div>
                    </div>
                    <div className="firstfield">
                      <div className="label">
                        <label htmlFor="">New Password</label>{" "}
                      </div>
                      <div className="inputfield">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter New Password"
                          value={restpassword}
                          onChange={(e) => {
                            setResetpassword(e.target.value);
                            setErrors((prev) => ({ ...prev, password: "" }));
                          }}
                        />
                        <div
                          className="eye-icon"
                          onClick={togglePasswordVisibility}
                        >
                          {showPassword ? (
                            <IoEyeOffSharp
                              color="gray"
                              width="18"
                              height="18"
                            />
                          ) : (
                            <IoEyeSharp color="gray" width="18" height="18" />
                          )}
                        </div>
                      </div>
                      <span style={{ color: "red" }}>{errors.password}</span>
                    </div>
                    <div className="firstfield">
                      <div className="label">
                        <label htmlFor="">Confirm Password</label>{" "}
                      </div>
                      <div className="inputfield">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          placeholder="Confirm New Password"
                          value={confirmPassword}
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            setErrors((prev) => ({
                              ...prev,
                              confirmPassword: "",
                            }));
                          }}
                        />
                        <div
                          className="eye-icon"
                          onClick={toggleConfirmPasswordVisibility}
                        >
                          {showConfirmPassword ? (
                            <IoEyeOffSharp
                              color="gray"
                              width="18"
                              height="18"
                            />
                          ) : (
                            <IoEyeSharp color="gray" width="18" height="18" />
                          )}
                        </div>
                      </div>
                      <span style={{ color: "red" }}>
                        {errors.confirmPassword}
                      </span>
                    </div>

                    <div className="firstfield d-none">
                      <div className="label">
                        <label htmlFor="">Email</label>{" "}
                      </div>
                      <div className="inputfield ">
                        <input
                          type="email"
                          placeholder="Email"
                          value={email}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className="card-bottom">
                  <div className="signin-btn">
                    {step === 1 ? (
                      <button disabled={sending} onClick={forgetPassword}>
                        {sending ? "Sending..." : "Send OTP"}
                      </button>
                    ) : (
                      <button onClick={resetpassword}>Reset Password</button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SignIn;
